/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react';
import { InfoCircle1 } from '../../icons/InfoCircle1';
import './style.css';

export const InfoCircle = () => {
    return <InfoCircle1 className="info-circle-1" />;
};
